/**
 * Compose Operation Manifest
 *
 * The Compose operation constructs an arbitrary object from its inputs.
 * It accepts any value (string, number, object, array, expression) and
 * outputs that value directly.
 */

import type { ConnectorInfo } from '@/types/operationManifest';

const composeManifest = {
  properties: {
    iconUri: 'https://logicapps.azureedge.net/icons/compose.svg',
    brandColor: '#8c6cff',
    description: 'Constructs an arbitrary object from the inputs.',

    // Compose has direct inputs - the entire inputs field IS the value, not an object with properties
    // This matches LogicAppsUX's pattern for direct-input operations
    inputs: {
      type: 'any',
      title: 'Inputs',
      description: 'The content to compose. Can be any value: string, number, object, array, or expression.',
      'x-ms-visibility': 'important',
    },

    outputs: {},

    // Connector info
    connector: {
      id: 'connectionProviders/dataOperationNew',
      name: 'dataOperationNew',
      properties: {
        displayName: 'Data Operations',
        iconUri: 'https://logicapps.azureedge.net/icons/compose.svg',
        brandColor: '#8c6cff',
        description: 'Data Operations',
      },
    } as ConnectorInfo,

    settings: {
      secureData: {},
      trackedProperties: {
        scopes: ['Action'],
      },
    },
  },
};

export default composeManifest;
